{
    "account": "Fiók",
    "add_bookmark": "Üzenet elrakása a könyvjelzőkhöz",
    "add_date": "Dátum hozzáadása",
    "ago": "{{duration}} ezelött",
    "api_key": "API kulcs",
    "are_you_sure": "Biztos vagy benne?",
    "ask_delete_message": "Biztos, hogy törlöd az üzenetet?",
    "audio_not_ready": "",
    "bookmark_added": "Üzenet hozzáadva a könyvjelzőkhöz !",
    "bookmark_removed": "Az üzenet eltávolítva a könyvjelzők közül!",
    "bookmarks": "könyvjelzők",
    "cancel": "Mégsem",
    "cancel_write": "Biztos, hogy megszakítód az új üzeneted írását?",
    "changed_group_name": "megváltoztatta a csoport nevét",
    "confirm_password_placeholder": "jelszó megerősítése",
    "connect": "Kapcsolat",
    "create_a_group": "Egy csoport létrehozása",
    "create_the_group": "A csoport létrehozása",
    "daily": "Napi",
    "default_group": "Alapértelmezett csoport",
    "delete": "Törlés",
    "destroy_account": "A fiók törlése",
    "destroy_account_explain": "Miután törölte a fiókját, nincs visszaút. Kérlek, légy biztos.",
    "edit": "Szerkesztés",
    "email": "Email",
    "email_input": "Írd az email címedet ide",
    "empty_message": "Az üzenet üres és így nem küldhető el !",
    "error": "Hiba történt",
    "error_new_message": "Hiba történt az üzenet küldése közben.",
    "error_upload": "Hiba történt a feltöltés közben",
    "forgot_password": "Elfelejtetted a jelszavad?",
    "group_left": "Elhagytad a csoportot !",
    "groups": "Csoportok",
    "group_share_choice": "Melyik csoportnak szeretné elküldeni ezt az üzenetet?",
    "group_updated": "A csoport frissítve !",
    "has_commented_on": "hozzászolt",
    "has_joined": "csatlakozott",
    "has_left": "kilépett",
    "has_posted_in": "közzétéve",
    "hourly": "Óránként",
    "in": "ban",
    "Invalid login/password": "Hibás felhasználó és/vagy jelszó",
    "invitation_link": "Meghívó link",
    "invitation_welcome": "Üdvözöl a Zusam ! Regisztrálj mielött belépsz egy csoportba.",
    "just_now": "Csak most",
    "lang": "nyelv",
    "login": "Bejelentkezés",
    "login_input": "Válassz ki egy bejelentkezést",
    "login_placeholder": "email",
    "logout": "Kijelentkezés",
    "mark_all_as_read": "összes megjelölése olvasottként",
    "monthly": "Havi",
    "multiple_photos_upload": "Hiba történt. Próbáld a képeket egyesével feltölteni ( néhány böngészőben ez történhet ).",
    "name_input": "Válassz egy nevet",
    "name": "Név",
    "new_password_placeholder": "új jelszó",
    "next_coms": "Következő hozzászólások",
    "none": "Egyik sem",
    "notification_emails": "Email értesítések",
    "notification_emails_stopped": "Az e-mail értesítések leálltak !",
    "notifications": "értesítések",
    "parent_message": "Szülő üzenet",
    "password_input": "Írd ide az új jelszót",
    "password": "Jelszó",
    "password_placeholder": "jelszó",
    "password_reset_mail_sent": "A jelszóhelyreállító email el lett küldve!",
    "passwords_dont_match": "A jelszavak nem egyeznek",
    "previous_coms": "Korábbi hozzászólások",
    "public_link": "nyilvános link",
    "publish_in_group": "közzététel a csoportban",
    "quit_group": "Kilépés a csoportból",
    "remove_bookmark": "Üzenet könyvjelzőjének törlése",
    "replies_one": "{{count}} válasz",
    "replies_other": "{{count}} válasz",
    "reply": "válasz",
    "reset_api_key": "Az API-kulcs alaphelyzetbe állítása (megszakad a kapcsolat)",
    "reset_invitation_link": "Meghívó link alaphelyzetbe állítása",
    "reset_password_title": "Jelszó alaphelyzetbe állítás",
    "save_changes": "Változások mentése",
    "search_in_group": "keresés ebben a csoportban",
    "search_without_result": "A keresés nem egyezett egyetlen üzenettel sem.",
    "settings": "Beállítások",
    "settings_updated": "A beállítások frissültek",
    "share_message": "Az üzenet megosztása",
    "signup": "Regisztráció",
    "submit": "Küldés",
    "text_placeholder": "Írd ide az üzenetet",
    "the_message_from": "az üzenet küldője",
    "title_placeholder": "Üzenet címe (nem kötelező)",
    "to": "hoz",
    "upload_audio": "",
    "upload_image": "Fotók hozzáadása",
    "upload_music": "Zenék hozzáadása",
    "upload_pdf": "PDF hozzáadása",
    "upload_video": "Videó hozzáadása",
    "User not found": "Felhasználó nem található",
    "users": "felhasználók",
    "video_not_ready": "A videó még nem áll készen.",
    "weekly": "Heti"
}
